import EmblaCarousel from 'embla-carousel'

const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
  const togglePrevNextBtnsState = () => {
    if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled')
    else prevBtn.setAttribute('disabled', 'disabled')

    if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled')
    else nextBtn.setAttribute('disabled', 'disabled')
  }

  emblaApi
    .on('select', togglePrevNextBtnsState)
    .on('init', togglePrevNextBtnsState)
    .on('reInit', togglePrevNextBtnsState)

  return () => {
    prevBtn.removeAttribute('disabled')
    nextBtn.removeAttribute('disabled')
  }
}

const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
  const scrollPrev = () => {
    emblaApi.scrollPrev()
  }
  const scrollNext = () => {
    emblaApi.scrollNext()
  }
  prevBtn.addEventListener('click', scrollPrev, false)
  nextBtn.addEventListener('click', scrollNext, false)

  const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
    emblaApi,
    prevBtn,
    nextBtn
  )

  return () => {
    removeTogglePrevNextBtnsActive()
    prevBtn.removeEventListener('click', scrollPrev, false)
    nextBtn.removeEventListener('click', scrollNext, false)
  }
}

const initializeSlider = (className, options = { loop: true, align: 'start' }) => {
  const emblaNode = document.querySelector(`.${className}`)
  if (!emblaNode) return null

  const viewportNode = emblaNode.querySelector(`.${className}__viewport`)
  const prevBtnNode = emblaNode.querySelector(`.${className}__button--prev`)
  const nextBtnNode = emblaNode.querySelector(`.${className}__button--next`)

  if (!viewportNode || !prevBtnNode || !nextBtnNode) return null

  const emblaApi = EmblaCarousel(viewportNode, options)
  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
    emblaApi,
    prevBtnNode,
    nextBtnNode
  )

  emblaApi.on('destroy', removePrevNextBtnsClickHandlers)
  return emblaApi
}

// Initialize multiple sliders
const sliders = {
  popularAuthors: initializeSlider('popular-authors-slider'),
  columnsList: initializeSlider('columns-list-slider', {
    breakpoints: {
      '(max-width: 1024px)': { watchDrag: true, loop: true, align: 'start' },
      '(min-width: 1025px)': { watchDrag: false, loop: true, align: 'start' }
    }
  }),
  // Add more sliders here with different class names
  // example: newsSlider: initializeSlider('news-embla'),
  // example: featuredSlider: initializeSlider('featured-embla'),
}

export { initializeSlider, sliders }
